import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxMaskDirective } from 'ngx-mask';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DialogModule } from 'primeng/dialog';
import { CompanyService } from '../../services/company.service';
import { Messages, ValidationPatterns } from '../../../common/constants/messages';
import { HostListener } from '@angular/core';
import { CanComponentDeactivate } from '../../../app/guards/can-deactivate.interface';
import { UnsavedTrackingService } from '../../../services/unsaved-changes.service';
import { InvalidCharsPipe } from '../../../common/Helpers/invalid-chars.pipe';
import { ValidationHelper } from '../../../common/Helpers/validation-helper';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxSpinnerModule, NgxMaskDirective, DialogModule, InvalidCharsPipe],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.css'
})
export class UserProfileComponent implements CanComponentDeactivate {

  prefixList: any[] = [];
  suffixList: any[] = [];
  roleList: any[] = [
    { id: '2', name: 'Admin' },
    { id: '3', name: 'User' }
  ];
  roleCode = "";
  userEmail = "";
  pageMode = "";
  contact: any;
  companyId: any;
  contactId: any;
  profileForm!: FormGroup;
  isSaving = false;
  contactTypeCode: any;
  locListModalDlg = false;
  dialogSummary = '';
  dialogMsg = '';
  private resolveGuard!: (value: boolean) => void;
  private rejectGuard!: (value: boolean) => void;
  dialogType: 'success' | 'unsaved' | 'error' = 'success';
  readonly ValidationPatterns = ValidationPatterns;
  
  constructor(
    private fb: FormBuilder,
    private companyService: CompanyService,
    private http: HttpClient,
    private ngx: NgxSpinnerService,
    private router: Router,
    private unsavedService: UnsavedTrackingService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.roleCode = sessionStorage.getItem('roleCode')?.toString() || '';    
    this.userEmail = sessionStorage.getItem('email')?.toString() || '';
    this.companyId = sessionStorage.getItem('companyId')?.toString() || '';
    this.contactId = this.route.snapshot.paramMap.get('id');
    if(this.roleCode == '1')
    {
      this.roleList = [
    { id: '1', name: 'Super Admin' },
    { id: '2', name: 'Admin' },
    { id: '3', name: 'User' }
  ];
    }
    else if(this.roleCode == '2')
    {
      this.roleList = [   
    { id: '2', name: 'Admin' },
    { id: '3', name: 'User' }
  ];
    }
    else if(this.roleCode == '3')
    {
      this.roleList = [
         { id: '3', name: 'User' }
  ];
    }
    if (this.roleCode == "2" || this.roleCode == "1") {
      if (this.contactId)
        this.pageMode = "Edit";
      else
        this.pageMode = "Add";
    }
    else if (this.roleCode == "3") {
      if (this.contactId) {
        this.pageMode = "Edit";
      }
    }
    this.buildForm();
    this.unsavedService.registerForm(this.profileForm);
    this.loadDropdowns();
    this.getUserProfile(this.contactId);
  }

  @HostListener('window:beforeunload', ['$event'])
handleRefresh(event: BeforeUnloadEvent) {

  if (sessionStorage.getItem('isLoggingOut') === 'true') {
    return;
  }

  if (this.unsavedService.hasChanges(this.profileForm)) {
    event.preventDefault();
    event.returnValue = '';
  }
}

  buildForm(): void {
    const namePattern = new RegExp(
      ValidationPatterns.NAME,
      "u"
    );
    this.profileForm = this.fb.group({
      prefix: [''],
      firstName: ['', [Validators.required, Validators.pattern(namePattern)]],
      lastName: ['', [Validators.required, Validators.pattern(namePattern)]],
      suffix: [''],
      jobTitle: ['', [Validators.pattern(new RegExp(
        ValidationPatterns.JOB, "u"))]],
      phone: ['', [Validators.required, Validators.pattern(ValidationPatterns.PHONE)]],
      fax: ['', Validators.pattern(ValidationPatterns.PHONE)],
      email: ['' , [
        Validators.required,
        Validators.email
      ]
      ],
      roleCode: ['', Validators.required],
      phoneExt: [
  '',
  [
    Validators.maxLength(10),
    Validators.pattern(ValidationPatterns.PHONE)
  ]
],
    });
  }

  loadDropdowns(): void {
    this.companyService.getAllPrefixes().subscribe(d => (this.prefixList = d));
    this.companyService.getAllSuffixes().subscribe(d => (this.suffixList = d));
  }

  getUserProfile(id: number): void {
    this.companyService.getUserProfile(id).subscribe(d => {
      this.contact = d;

      this.companyId = d.companyId;
      this.contactId = d.contactId;
      this.profileForm.get('prefix')?.setValue(this.toEmpty(d.prefixCode));
      this.profileForm.get('firstName')?.setValue(d.firstName);
      this.profileForm.get('lastName')?.setValue(d.lastName);
      this.profileForm.get('suffix')?.setValue(this.toEmpty(d.suffixCode));
      this.profileForm.get('jobTitle')?.setValue(d.jobTitle);
      this.profileForm.get('phone')?.setValue(d.contactPhone);
      this.profileForm.get('phoneExt')?.setValue(d.contactPhoneExtension);
      this.profileForm.get('fax')?.setValue(d.fax);
      this.profileForm.get('email')?.setValue(d.email);
      this.profileForm.get('roleCode')?.setValue(d.roleCode);
      this.profileForm.patchValue({
        prefix: this.toEmpty(d.prefixCode),
        firstName: d.firstName,
        lastName: d.lastName,
        suffix: this.toEmpty(d.suffixCode),
        jobTitle: d.jobTitle,
        phone: d.contactPhone,
        phoneExt: d.contactPhoneExtension,
        fax: d.fax,
        email: d.email,
        roleCode: d.roleCode
      });
      this.profileForm.markAsPristine();
      this.unsavedService.markSaved(this.profileForm);
    }

    );
  }

  allowNumbersOnly(event: Event, controlPath: string): void {
  ValidationHelper.allowNumbersOnly(
    event,
    this.profileForm,
    controlPath,
    10
  );
}


  submit(): void {

    if (this.profileForm.invalid) {
      this.profileForm.markAllAsTouched();
      this.dialogSummary = Messages.ValidationTitle;
      this.dialogMsg = Messages.ValidationMessage;
      this.locListModalDlg = true;
      return;
    }

    this.updateUserProfile();
  }

  cancel(): void {
    this.router.navigate(['/account-settings']);
  }

  canDeactivate(): Promise<boolean> | boolean {

    if (sessionStorage.getItem('isLoggingOut') === 'true') {
      return true;
    }

     if (!this.unsavedService.hasChanges(this.profileForm)) {
      return true;
    }

    this.dialogSummary = 'Unsaved Changes';
    this.dialogMsg =
      'You have unsaved changes. Are you sure you want to cancel? Your progress will be lost.';

    this.dialogType = 'unsaved';
    this.locListModalDlg = true;

    return new Promise<boolean>((resolve) => {
      this.resolveGuard = resolve;
    });
  }
  stayOnPage() {
    this.locListModalDlg = false;

    if (this.resolveGuard) {
      this.resolveGuard(false);
    }
  }

  leavePage() {
    this.locListModalDlg = false;

    if (this.resolveGuard) {
      this.resolveGuard(true);
    }
  }
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.profileForm?.dirty) {
      $event.returnValue = true;
    }
  }
  updateUserProfile(): void {
    this.ngx.show();
    this.isSaving = true;

    const payload: any = {
      companyId: this.companyId,
      contactId: this.contactId,
      prefixCode: this.toNull(this.profileForm.value.prefix),
      firstName: this.profileForm.value.firstName.trim(),
      lastName: this.profileForm.value.lastName.trim(),
      suffixCode: this.toNull(this.profileForm.value.suffix),
      jobTitle: this.profileForm.value.jobTitle.trim(),
      contactPhone: this.profileForm.value.phone,
      contactPhoneExtension: this.profileForm.value.phoneExt,
      fax: this.profileForm.value.fax,
      email: this.profileForm.value.email,
      roleCode: this.profileForm.value.roleCode
    };

    if (this.pageMode === "Edit") {
      this.companyService.updateUserProfile(payload).subscribe({
        next: () => {
          this.ngx.hide();
          this.isSaving = false;
          // show dialog
          this.dialogSummary = Messages.SuccessTitle;
          this.dialogMsg = Messages.UserProfileSuccessMessage;
          this.locListModalDlg = true;
          this.dialogType = 'success';
          this.profileForm.markAsPristine();
          this.unsavedService.markSaved(this.profileForm);
        },
        error: (err) => {
          this.ngx.hide();
          this.isSaving = false;
          this.dialogSummary = Messages.ErrorTitle;
          this.dialogMsg = Messages.SaveFailedMessage;
          this.locListModalDlg = true;
        }
      });
    }
    else if (this.pageMode === "Add") {
      this.companyService.createUserProfile(payload).subscribe({
        next: (res) => {
          this.ngx.hide();
          this.isSaving = false;
          // show dialog
          if (res && res.isSuccess) {
            this.dialogSummary = Messages.SuccessTitle;
            this.dialogMsg = Messages.UserProfileSuccessMessage;
            this.locListModalDlg = true;
            this.profileForm.reset();
            this.dialogType = 'success';
            this.unsavedService.markSaved(this.profileForm); 
          }
          else {
            this.ngx.hide();
            this.isSaving = false;
            this.dialogSummary = Messages.ValidationTitle;
            this.dialogMsg = res.errorMessage;
            this.locListModalDlg = true;
          }
        },
        error: (err) => {
          this.ngx.hide();
          this.isSaving = false;
          this.dialogSummary = Messages.ErrorTitle;
          this.dialogMsg = Messages.SaveFailedMessage;
          this.locListModalDlg = true;
        }
      });
    }
  }

  okClickedV2() {
    this.locListModalDlg = false;
    if (this.dialogSummary === Messages.SuccessTitle) {
      this.router.navigate(['/account-settings']);
    }
  }


  // Utitlity Functions
  toNull(value: any) {
    return value === '' || value === undefined ? null : value;
  }

  toEmpty(value: any) {
    return value === null || value === undefined ? '' : value;
  }

  isFieldInvalid(path: string): boolean {
    const control = this.profileForm.get(path);
    return !!(control && control.invalid && control.touched);
  }

  displayFieldCss(path: string) {
    return { 'has-error': this.isFieldInvalid(path) };
  }

}
